var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisplayPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 4,
    fill: "#FF2953"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 8.77148C12.2297 8.77148 13.2266 9.76835 13.2266 10.998C13.2266 12.2277 12.2297 13.2246 11 13.2246C9.7703 13.2246 8.77344 12.2277 8.77344 10.998C8.77344 9.76835 9.7703 8.77148 11 8.77148Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.046875
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9878 5.39795C12.5106 5.39795 14.0547 5.84624 15.4722 6.69775L15.7534 6.87354C17.019 7.69081 18.1567 8.8138 19.0591 10.1343L19.2368 10.4009C19.3517 10.579 19.413 10.7866 19.4136 10.9985L19.4028 11.1567C19.3881 11.261 19.3584 11.3626 19.3149 11.4585L19.2397 11.5972C18.3725 12.9545 17.2622 14.1155 16.0151 14.9712L15.7642 15.1382C14.2774 16.0954 12.6251 16.6011 10.9878 16.6011C9.41829 16.601 7.90612 16.1693 6.49072 15.3169L6.2085 15.1411C4.96313 14.3352 3.83744 13.2115 2.93799 11.8794L2.76025 11.6099C2.64228 11.4268 2.58153 11.2124 2.58545 10.9946L2.6001 10.8325C2.61798 10.726 2.65169 10.6226 2.69971 10.5259L2.78271 10.3862C3.83747 8.87407 5.04141 7.67908 6.36475 6.82959L6.63135 6.66455C8.03206 5.82426 9.49776 5.39804 10.9878 5.39795ZM12.3003 7.85986C11.757 7.63491 11.1662 7.55505 10.5854 7.62646L10.3374 7.6665C9.7607 7.78122 9.225 8.04328 8.78174 8.42529L8.59717 8.59619C8.18122 9.01214 7.88137 9.52812 7.7251 10.0923L7.66748 10.3364C7.55277 10.9131 7.58966 11.5083 7.77295 12.064L7.86084 12.3003C8.08596 12.8436 8.44736 13.318 8.90869 13.6782L9.11182 13.8257C9.60095 14.1525 10.1657 14.345 10.7495 14.3882L11.0005 14.3979C11.8449 14.3969 12.6567 14.0821 13.2798 13.5181L13.4019 13.4019C14.039 12.7648 14.3979 11.9005 14.3989 10.9995L14.3892 10.7485C14.3521 10.2482 14.2047 9.76231 13.9575 9.32568L13.8257 9.11182C13.4523 8.55295 12.9213 8.11708 12.3003 7.85986Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.046875
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisplayPlan);
export default __webpack_public_path__ + "static/media/display-plan.d99970dceb4954c7498171c725cfd41e.svg";
export { ForwardRef as ReactComponent };